{
  "version": 1,
  "asset_id": "5f99ff97-91ad-49c6-a774-c9900641b975",
  "project_id": "42f7b672-abb9-48a4-a474-c45868224dff",
  "url": "/img2.jpeg",
  "original_filename": "img2.jpeg",
  "content_type": "image/jpeg",
  "alt": "Share The Med Logo (Navy)"
}
